import { render } from "./StaticHeader.vue?vue&type=template&id=b860626a"
import script from "./StaticHeader.vue?vue&type=script&lang=js"
export * from "./StaticHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__